import { FC } from "react";
import { CommonInputControlsProps } from "./types";
import { VoidFunc } from "../../../helpers/functions/types";
import { LabelAtom } from "./atoms/LabelAtom";
import { NAMED_WRAPPER_STYLES } from "./constants";
import { RadioAtom } from "./atoms/RadioAtom";

export type RadioGroupStyleVariant = "buttons" | "wideButtons" | "icons";

type GroupData = {
  value: string;
  title?: string;
  disabled?: boolean;
  icon?: JSX.Element;
}[];

const BUTTONS_WRAPPER_STYLES = `px-4 py-4 ${NAMED_WRAPPER_STYLES}`;

const NAMED_RADIO_WRAPPER_STYLES: Record<RadioGroupStyleVariant, string> = {
  buttons: BUTTONS_WRAPPER_STYLES,
  wideButtons: BUTTONS_WRAPPER_STYLES,
  icons: "",
};

export const NamedRadio: FC<
  React.PropsWithChildren<
    CommonInputControlsProps<string, VoidFunc<string>> & {
      disabledMessage?: string;
      requiredMessage?: string;
      options: GroupData;
      radioVariant?: RadioGroupStyleVariant;
    }
  >
> = ({
  value,
  customId,
  title,
  onChange,
  disabledMessage,
  requiredMessage,
  options,
  radioVariant = "buttons",
}) => {
  return (
    <div className={NAMED_RADIO_WRAPPER_STYLES[radioVariant]}>
      <LabelAtom
        title={title}
        htmlFor={customId ?? title}
        srOnly={radioVariant === "icons"}
      />
      <RadioAtom
        initValue={value}
        onChange={onChange}
        requiredMessage={requiredMessage}
        customId={customId ?? title}
        disabledMessage={disabledMessage}
        options={options}
        radioVariant={radioVariant}
      />
    </div>
  );
};
